module.exports = __webpack_public_path__ + "img/btn-taptap@2x.24d0214f.png";